import InventoryFullPageCard from "./InventoryFullPageCard";

export default InventoryFullPageCard;
